import { createSlice } from "@reduxjs/toolkit";
import { getAllMenuAction, insertUpdateMenuAction, menuStatusChangeACTION } from "../../actions/menuActions/menuActions.js";
import { toast } from 'react-toastify';

const INITIAL_STATE = {

    Menus: {
        data: {},
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },

    insertUpdateMenusDetails: {
        data: {},
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        newRecord: false
    },

    activeInactiveMenuDetails: {
        data: {},
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },

}

const MenuReducer = createSlice({
    name: "Menus",
    initialState: INITIAL_STATE,
    reducers: {
        RESET(state, action) {
            state = INITIAL_STATE;
        },
        ResetstateMenu(state, action) {
            // state.Menus = INITIAL_STATE.Menus;
            state.insertUpdateMenusDetails = INITIAL_STATE.insertUpdateMenusDetails;
        },
    },

    extraReducers: (builder) => {
        builder.addCase(getAllMenuAction.fulfilled, (state, action) => {
            // console.log("getAllMenuAction success", action);
            state.Menus.data = action.payload.data.records;
            // console.log(state.Menus.data , 'given data');
            state.Menus.apiMsg.status = action.meta.requestStatus;
            state.Menus.apiMsg.message = "success";
            // console.log(state.getAllMenu.apiMsg.message,'apimsg');
        });
        builder.addCase(getAllMenuAction.pending, (state, action) => {
            // console.log("getAllMenuAction pending", action);
            state.Menus.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(getAllMenuAction.rejected, (state, action) => {
            // console.log("getAllMenuAction rejected", action);
            state.Menus.apiMsg.message = action.error.message;
            state.Menus.apiMsg.status = action.meta.requestStatus;
        });


        //insertupdate reducer

        builder.addCase(
            insertUpdateMenuAction.fulfilled,
            (state, action) => {

                state.insertUpdateMenusDetails.data = action.payload.data.data;
                state.insertUpdateMenusDetails.apiMsg.status = action.meta.requestStatus;
                state.insertUpdateMenusDetails.apiMsg.message = action.payload.message.message;

                // console.log(action.payload.data.data, 'reducerdata')

                if (!action.payload.newRecord) {
                    // let updatedRecord = state.Menus.data.records.map(x => {
                    //     if (x.id == action.payload.data.data.id) {
                    //         console.log(action.payload.data, 'updated Data');
                    //         return action.payload.data.data;
                    //     }
                    //     else {
                    //         return x;
                    //     }
                    // })

                    // state.getAllCategory.data.records = updatedRecord;
                }
                else {
                    if (state.Menus.data.records) {
                        state.Menus.data.records.unshift(action.payload.data.data);
                    }
                    else {
                        // state.Menus.data.records.push(action.payload.data.data);
                    }
                }
                toast.success(action.payload.message.message, {
                    position: 'bottom-center',
                    toastId: "dept-error"
                });
            }
        );

        builder.addCase(
            insertUpdateMenuAction.pending,
            (state, action) => {
                state.insertUpdateMenusDetails.apiMsg.status = action.meta.requestStatus;
            }
        );
        builder.addCase(
            insertUpdateMenuAction.rejected,
            (state, action) => {

                console.log(action.error.message);
                state.insertUpdateMenusDetails.apiMsg.message = action.error.message;
                state.insertUpdateMenusDetails.apiMsg.status = action.meta.requestStatus;

                toast.error(action.error.message ? action.error.message : "Something went wrong please try again", {
                    position: 'bottom-center',
                    toastId: "dept-error"
                });
            }
        );

        
        //active Inactive

        builder.addCase(menuStatusChangeACTION.fulfilled, (state, action) => {
            // console.log(action.payload, 'reducer payload');
            // state.activeInactiveMenuDetails.data.records = state.activeInactiveMenuDetails.data.records.map((item) => {

            //     return {
            //         ...item,
            //         active: action.payload.id === item.id ? !item.active : item.active
            //     }
            // })

            state.activeInactiveMenuDetails.data = action.payload.data;
            state.activeInactiveMenuDetails.apiMsg.status = action.meta.requestStatus;
            state.activeInactiveMenuDetails.apiMsg.message = action.payload.message.message;
            
            toast.success(action.payload.message.message, {
                position: 'bottom-center',
                toastId: "dept-error"
            });

        });

        builder.addCase(menuStatusChangeACTION.pending, (state, action) => {
            state.activeInactiveMenuDetails.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(menuStatusChangeACTION.rejected, (state, action) => {
            state.activeInactiveMenuDetails.apiMsg.message = action.error.message;
            state.activeInactiveMenuDetails.apiMsg.status = action.meta.requestStatus;
        });

    }
})
export default MenuReducer.reducer;
export const { RESET, ResetstateMenu } = MenuReducer.actions;
